import { useEffect } from "react";

import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { setShowSearch } from "../../store/appConfigsSlice";

import { SupportTicketView } from "../../components/support";

const SupportTicketPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowSearch(false));
  }, [dispatch]);

  return <SupportTicketView />;
};

export default withTranslation()(SupportTicketPage);
